var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-card-foot-progress',{attrs:{"value":_vm.winPercent,"color":_vm.item.game.color,"invalid":_vm.winPercent === false,"text":_vm.field.label}})
}
var staticRenderFns = []

export { render, staticRenderFns }